import {
  Dialog,
  DialogContent,
  DialogContentText,
  IconButton,
  TextareaAutosize
} from "@material-ui/core";
import Axios from "axios";
import { debounce } from "lodash";
import React, { useState } from "react";
import { Form } from "react-bootstrap";

function ShowNoteComponent(props) {
  const [open, setOpen] = useState(false);
  const {row, api} = props;

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleChange = debounce(async (property, value) => {
      try {
        if (value && value._isAMomentObject) {
          const date_dt = new Date(value);
          const new_date = new Date(
            date_dt.getFullYear(),
            date_dt.getMonth(),
            date_dt.getDate(),
            10,
            56,
            0
          );
          row[property] = new_date;
        } else {
          row[property] = value;
        }
  
        const response = await Axios.put(
          `${api}/${row.id}`,
          row
        );
  
      } catch (err) {
        console.error("Error updating property:", err);
      }
    }, 500);

  return (
    <>
      <div
        className={`btn btn-icon ${
          row.notes ? "btn-success" : "btn-light"
        } btn-hover-light btn-sm mx-3 h-0 w-0`}
      >
        <IconButton aria-label="Delete" onClick={handleClickOpen}>
          <i className="fas fa-sticky-note"></i>
        </IconButton>
      </div>

      <Dialog
        fullWidth={true}
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <DialogContentText>
            <div className="login-form login-signin" id="kt_login_signin_form">
              {/*begin::Form*/}
              <form className="form fv-plugins-bootstrap fv-plugins-framework">
                <div className="form-group fv-plugins-icon-container">
                  <Form.Label className="font-weight-bold text-uppercase fs-1">
                    Notes
                  </Form.Label>
                  <TextareaAutosize
                    type="text"
                    defaultValue={row.notes}
                    onChange={(e) => handleChange('notes', e.target.value)}
                    className={`form-control form-control-solid  py-5 px-6 `}
                    placeholder="Empty" 
                  />

                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block"></div>
                  </div>
                </div>
              </form>
              {/*end::Form*/}
            </div>
          </DialogContentText>
        </DialogContent>
      </Dialog>
    </>
  );
}
export default ShowNoteComponent;
